import React, { useState } from 'react';
import { defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { TagsDataProvider } from 'components/activity/graphql/TagsDataProvider';
import TagsModal from 'components/activity/TagsModal';
import { ccIntl } from 'helpers/intl-helper';
import RecordableTypes from 'constants/recordableTypes';
import { ButtonCondensed } from '@companycam/slab-web';

defineMessages({
  manageButton: {
    id: 'Activity.TagContainer.manageButton',
    defaultMessage: 'Add Tags',
    description: 'Add Tag Button',
  },
  updateTags: {
    id: 'Activity.TagContainer.updateTags',
    defaultMessage: 'Save Tags',
    description: 'Save Tags Button',
  },
});

const TagContainer = ({ nodeId, recordableType }) => {
  const [tagModalVisible, setTagModalVisible] = useState(false);

  return (
    <TagsDataProvider variables={{ nodeId }}>
      {({ fetchingResults, fetchError, tags }) => {
        const { formatMessage } = ccIntl;
        const manageButton = formatMessage({
          id: 'Activity.TagContainer.manageButton',
        });
        const updateTags = formatMessage({
          id: 'Activity.TagContainer.updateTags',
        });

        const hasLoaded = !fetchingResults && !fetchError;
        const displayTagsModal = tagModalVisible && hasLoaded;

        const tagComponents = (tags || []).map((tag) => {
          return (
            <li key={tag.id}>
              <i className="mdi mdi-tag-outline" />
              {tag.displayValue}
            </li>
          );
        });
        return (
          <>
            <ul className="single-meta-tags">
              <ButtonCondensed
                data-testid="asset__add-tags-button"
                color="primary"
                icon={{
                  name: 'tag-multiple-outline',
                  position: 'before',
                }}
                onClick={() => {
                  if (hasLoaded) {
                    setTagModalVisible(true);
                  }
                }}
              >
                {manageButton}
              </ButtonCondensed>
              {tagComponents}
            </ul>
            {displayTagsModal ? (
              <TagsModal
                action="REPLACE"
                originalTags={tags}
                nodeIds={[nodeId]}
                onRequestClose={() => {
                  setTagModalVisible(false);
                }}
                buttonTitle={updateTags}
                recordableType={recordableType}
              />
            ) : null}
          </>
        );
      }}
    </TagsDataProvider>
  );
};

TagContainer.propTypes = {
  nodeId: PropTypes.string,
  recordableType: PropTypes.oneOf([
    RecordableTypes.PHOTO,
    RecordableTypes.VIDEO,
  ]).isRequired,
};

export default TagContainer;
